import React from 'react';
import { Link } from 'react-router-dom';

const CumFunctioneaza: React.FC = () => {
  return (
    <div className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-center mb-8">Cum Funcționează</h1>
          
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="space-y-8">
              {/* Pentru Clienți */}
              <div>
                <h2 className="text-2xl font-semibold mb-4">Pentru Clienți</h2>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                      1
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">Publică Proiectul</h3>
                      <p className="text-gray-600">Completează formularul cu detaliile proiectului tău, inclusiv bugetul, locația și cerințele specifice.</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                      2
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">Primește Oferte</h3>
                      <p className="text-gray-600">Profesioniști calificați îți vor trimite oferte personalizate pentru proiectul tău.</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                      3
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">Alege și Colaborează</h3>
                      <p className="text-gray-600">Selectează cel mai potrivit consultant și începe colaborarea pentru a-ți transforma ideile în realitate.</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Pentru Profesioniști */}
              <div className="pt-8 border-t">
                <h2 className="text-2xl font-semibold mb-4">Pentru Profesioniști</h2>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                      1
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">Creează Profilul</h3>
                      <p className="text-gray-600">Completează profilul tău cu experiență, expertiză și realizări anterioare.</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                      2
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">Aplică la Proiecte</h3>
                      <p className="text-gray-600">Explorează proiectele disponibile și trimite oferte personalizate clienților.</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                      3
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">Colaborează</h3>
                      <p className="text-gray-600">Lucrează cu clienții și dezvoltă portofoliul tău cu proiecte de succes.</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="pt-8 border-t">
                <h2 className="text-2xl font-semibold mb-4">Începe Acum</h2>
                <p className="text-gray-600 mb-6">
                  Fie că ești client sau profesionist, platforma noastră te ajută să găsești partenerii potriviți pentru proiectele tale.
                </p>
                <div className="flex gap-4">
                  <Link
                    to="/publish-project"
                    className="flex-1 py-3 bg-primary text-white text-center rounded-lg hover:bg-primary-dark transition-colors"
                  >
                    Publică un Proiect
                  </Link>
                  <Link
                    to="/projects"
                    className="flex-1 py-3 bg-white text-primary border border-primary text-center rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    Vezi Proiecte
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CumFunctioneaza; 